var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypescript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 73,
    viewBox: "0 0 73 73",
    width: 73,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 69,
    rx: 14,
    width: 69,
    x: 4,
    y: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "nonzero",
    height: 71,
    rx: 14,
    stroke: "#035",
    strokeWidth: 2,
    width: 71,
    x: 3,
    y: 3
  }), /*#__PURE__*/React.createElement("rect", {
    height: 71,
    rx: 14,
    stroke: "#035",
    strokeWidth: 2,
    width: 71,
    x: 3,
    y: 3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#007acc",
    fillRule: "nonzero",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 36.5v-36.5h36.5 36.5v36.5 36.5h-36.5-36.5zm58.8287302 2.9084127c1.8539682-.4634921 3.267619-1.2861905 4.5653968-2.6303175.6720635-.7184127 1.6685714-2.0277777 1.7496825-2.3406349.0231746-.0926984-3.151746-2.2247619-5.0752381-3.418254-.0695238-.0463492-.347619.2549207-.6604762.7184127-.9385714 1.3673016-1.923492 1.958254-3.4298412 2.0625397-2.2131746.150635-3.6384127-1.0080952-3.6268254-2.9431746 0-.5677778.0811111-.9038095.3128571-1.3673016.4866667-1.0080952 1.3904762-1.6106349 4.2293651-2.8388888 5.225873-2.2479366 7.4622222-3.7311112 8.8526984-5.84 1.5526984-2.3522223 1.9003175-6.106508.845873-8.8990477-1.1587301-3.03587298-4.0323809-5.09841267-8.0763492-5.78206346-1.2514286-.22015873-4.2177778-.18539683-5.5619047.05793651-2.9315873.52142857-5.7125397 1.96984127-7.4274604 3.87015875-.6720635.7415873-1.9814285 2.6766666-1.9003174 2.8157143.0347619.0463492.3360317.231746.6720635.4287301.3244444.1853968 1.5526984.8922222 2.7114285 1.5642857l2.0973016 1.2166667.4403175-.6488889c.614127-.9385714 1.958254-2.2247619 2.7693651-2.653492 2.3290476-1.228254 5.5271428-1.0544445 7.1030158.3592063.6720635.614127.9501588 1.2514286.9501588 2.19 0 .845873-.1042857 1.2166667-.5446032 1.8539683-.5677778.8111111-1.7265079 1.4947619-5.0173016 2.92-3.765873 1.6222222-5.3880952 2.6303174-6.8712698 4.229365-.8574604.9269842-1.6685715 2.4101588-2.0046032 3.65-.2780952 1.0312699-.3476191 3.6152381-.1274603 4.6580953.7763492 3.6384127 3.5225397 6.1760317 7.4853968 6.9292063 1.2861905.2433334 4.2757143.1506349 5.5387302-.1622222zm-17.1376191-3.0474603.0231746-2.9895238h-4.7507936-4.7507937v-13.4992064-13.49920633h-3.3603174-3.3603175v13.49920633 13.4992064h-4.7507937-4.7507936v2.9315873c0 1.6222222.0347619 2.9779365.0811111 3.0126984.0347619.0463492 5.8168254.0695238 12.8271429.0579365l12.757619-.0347619z",
    transform: "matrix(1 0 0 -1 0 73)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.a31ffd17856fbb47ddc9d28637de28d2.svg";
export { ForwardRef as ReactComponent };